export enum Workflows {
    EthPlusWithdraw = 'EthPlusWithdraw',
    ConvexClaimRewards = 'ConvexClaimRewards',
}